import React from "react";

// A status control you choose from, not one you click through.
//
// This replaces a pill wired to a STATUS_CYCLE map, where each click advanced to
// the next status in a fixed loop. Reaching a status meant clicking past every
// one before it, and one click too many landed on a terminal status — on Bills
// that is "Paid", which the list filters out, so the row vanished mid-correction.
//
// A native <select> rather than a custom popup: keyboard accessible, correct on
// touch, no click-outside or focus handling to get wrong, and it cannot move to
// a value nobody picked.
//
// `cfg` is the page's own STATUS_CFG ({ [status]: { label, bg, color } }), so the
// colour coding a row is read by at a glance is unchanged.
export function StatusSelect({ value, options, cfg, onChange, disabled = false, title }) {
  const current = cfg[value] || cfg[options[0]] || { label: value, bg: "#f1f5f9", color: "#64748b" };

  return (
    <select
      value={value}
      disabled={disabled}
      title={title}
      onClick={(e) => e.stopPropagation()}
      onChange={(e) => {
        e.stopPropagation();
        // A select fires change only on an actual change, but guard anyway so a
        // re-pick of the current value never costs a request.
        if (e.target.value !== value) onChange(e.target.value);
      }}
      style={{
        // Keeps the pill's look so rows read the same as before.
        fontSize: "11px",
        fontWeight: 700,
        padding: "3px 6px",
        borderRadius: "10px",
        backgroundColor: current.bg,
        color: current.color,
        border: "none",
        outline: "none",
        cursor: disabled ? "default" : "pointer",
        opacity: disabled ? 0.5 : 1,
        transition: "opacity 0.15s",
        maxWidth: "100%",
      }}
    >
      {options.map((opt) => (
        // The options themselves stay on the browser's default white: a native
        // dropdown list painted in four different status colours is far harder
        // to read than the closed control it came from.
        <option key={opt} value={opt} style={{ backgroundColor: "#ffffff", color: "#0f172a" }}>
          {(cfg[opt] || {}).label || opt}
        </option>
      ))}
    </select>
  );
}
